import { render } from "./TransportDhlParcelShop.vue?vue&type=template&id=b61584ca"
import script from "./TransportDhlParcelShop.vue?vue&type=script&lang=js"
export * from "./TransportDhlParcelShop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__